const Info = ({ children }) => (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 text-blue-700 mb-4 rounded">
      <p className="font-bold">Info</p>
      <p>{children}</p>
    </div>
  );
  
  export default Info;
  